"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var currency_js_1 = __importDefault(require("currency.js"));
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var tooltip_1 = __importDefault(require("../../../../plugins/tooltip"));
var PaymentBlock = function (_a) {
    var customerStoreCreditBalance = _a.customerStoreCreditBalance;
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'position-relative' },
            React.createElement(react_router_dom_1.Link, { className: 'position-absolute z20 top-0 left-0 height-100 width-100', to: '/payment' }),
            React.createElement("div", { className: 'account-container padding-vertical-4 padding-horizontal-3 bg-white bordered border-very-light-pink grid-x grid-padding-x' },
                React.createElement("div", { className: 'cell small-8 text-left font-size-14 padding-left-4 flex-container items-center' },
                    React.createElement("img", { className: 'h-4 padding-right-3', src: window.accountApp.iconUrls.briefcase, alt: 'Briefcase icon' }),
                    "Payment"),
                React.createElement("div", { className: 'cell small-4 text-right flex-container items-center justify-end space-x-2' },
                    customerStoreCreditBalance !== undefined && customerStoreCreditBalance > 0 && (React.createElement("div", { className: 'padding-2 z100 bg-seashell font-size-12 font-lighter rounded-md flex-container space-x-1', style: { whiteSpace: 'nowrap' } },
                        React.createElement(tooltip_1.default, { button: React.createElement("i", { className: 'ss-info font-size-14 font-lighter', style: { verticalAlign: 'middle', lineHeight: '100%' } }) },
                            React.createElement("div", { className: 'padding-3 font-size-small' }, "Your Store Credit will be automatically applied to your next order, after shipping and taxes.")),
                        React.createElement("div", null,
                            "$",
                            (0, currency_js_1.default)(customerStoreCreditBalance).toString(),
                            " Store Credit"))),
                    React.createElement("div", null,
                        React.createElement("i", { id: 'show-payment', className: 'ss-right' })))))));
};
exports.default = PaymentBlock;
